import "./src/styles/global.scss"
import React from "react"

import { AppProvider } from "@components/context"

export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>
}
